import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchPettyCashCommonRequestMasterList = createAsyncThunk(
	"fetchPettyCashCommonRequestMasterList",
	async ({ page = 1, limit = 100 } = {}, { rejectWithValue }) => {
		try {
			const params = new URLSearchParams({
				is_common_valut: "true",
				page,
				limit,
			});
			const response = await axiosHttp.get(`/petty-cash/masters?${params}`);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestMasterListSlice = createSlice({
	name: "PettyCashCommonRequestMasterListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestMasterListState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashCommonRequestMasterList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchPettyCashCommonRequestMasterList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashCommonRequestMasterList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestMasterListState } = PettyCashCommonRequestMasterListSlice.actions;
export default PettyCashCommonRequestMasterListSlice.reducer;
